import { Action } from 'redux';

import { ApproveGroupMembershipRequestClients, DenyGroupMembershipRequestClients } from '../../normalization/types';
import { Group, Notification, User } from '../../state/types';

export interface ResolveGroupMembershipFromMembershipPanelOptions {
  readonly groupId: Group['id'];
  readonly userId: User['id'];
  readonly confirmationAnnouncement: string;
}
export interface ApproveGroupMembershipResponse {
  readonly data: ApproveGroupMembershipRequestClients;
}

export interface DenyGroupMembershipResponse {
  readonly data: DenyGroupMembershipRequestClients;
}

export interface ResolveGroupMembershipPendingAction extends Action {
  readonly type: 'GROUP.RESOLVE_MEMBERSHIP_REQUEST_PENDING';
  readonly payload: {
    readonly groupMembershipRequestId: string;
  };
}

export interface ResolveGroupMembershipFromNotificationFulfilledAction extends Action {
  readonly type: 'GROUP.RESOLVE_MEMBERSHIP_REQUEST_FULFILLED';
  readonly payload: {
    readonly groupMembershipRequestId: string;
    readonly notificationId: Notification['id'];
  };
}

export interface ResolveGroupMembershipFromMembershipPanelFulfilledAction extends Action {
  readonly type: 'GROUP.RESOLVE_MEMBERSHIP_REQUEST_FULFILLED';
  readonly payload: {
    readonly requestType: GroupMembershipRequestType;
    readonly groupMembershipRequestId: string;
    readonly groupId: Group['id'];
    readonly userId: User['id'];
  };
}

export interface ResolveGroupMembershipRejectedAction extends Action {
  readonly type: 'GROUP.RESOLVE_MEMBERSHIP_REQUEST_REJECTED';
  readonly payload: {
    readonly groupMembershipRequestId: string;
    readonly error: unknown;
  };
  readonly error: true;
}

export enum GroupMembershipRequestType {
  Approve = 'approve',
  Deny = 'deny',
}

export type ResolveGroupMembershipAction =
  | ResolveGroupMembershipPendingAction
  | ResolveGroupMembershipFromMembershipPanelFulfilledAction
  | ResolveGroupMembershipFromNotificationFulfilledAction
  | ResolveGroupMembershipRejectedAction;
